import {Filter} from '@/types/filter';

export const isNotEqualFilter = (a: Filter, b: Filter): boolean => {
  return JSON.stringify(a) !== JSON.stringify(b);
};
